import React from 'react';
import { FiInstagram, FiFacebook, FiMail, FiPhone, FiChevronUp } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const Footer = ({ setLegalContent }) => {
  const whatsappNumber = "221704567070"; // Ton numéro sans le +
  const email = "afrooptic@hotmail.com";
  const phone = "+221 70 456 70 70";

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0f0f0f] text-slate-400 border-t border-white/5 pt-12 pb-6 mt-auto" id='contacts'>
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-10">
          
          {/* 1. Identité & Contact Direct */}
          <div className="flex flex-col items-center md:items-start space-y-3">
            <div className="text-2xl font-bold tracking-tighter text-white">
              AFRO<span className="text-blue-500">OPTIC</span>
            </div>
            <div className="flex flex-col items-center md:items-start space-y-1 text-sm">
              <a href={`mailto:${email}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <FiMail className="text-blue-500" /> {email}
              </a>
              <a href={`tel:${phone}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <FiPhone className="text-blue-500" /> {phone}
              </a>
            </div>
          </div>

          {/* 2. Réseaux Sociaux (Bulles stylisées) */}
          <div className="flex items-center gap-5">
            <a href="https://www.facebook.com/106368938492287/" target="_blank" rel="noreferrer" 
               className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-blue-600 hover:text-white transition-all">
              <FiFacebook size={20} />
            </a>
            <a href="https://www.instagram.com/afro_optic/" target="_blank" rel="noreferrer"
               className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-pink-600 hover:text-white transition-all">
              <FiInstagram size={20} />
            </a>
            <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noreferrer"
               className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-green-600 hover:text-white transition-all">
              <FaWhatsapp size={20} />
            </a>
          </div>

          {/* 3. Bouton Retour en haut & Copyright */}
          <div className="flex flex-col items-center md:items-end gap-4">
            <button onClick={scrollToTop} className="...">
              <FiChevronUp size={24} />
            </button>
            <div className="flex flex-col items-center md:items-end gap-1">
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-600">
                © 2026 AfroOptic • Dakar, Sénégal
              </p>
              <div className="flex gap-3 text-[9px] uppercase tracking-widest text-slate-500">
                <button onClick={() => setLegalContent('mentions')} className="hover:text-blue-500">Mentions</button>
                <span>•</span>
                <button onClick={() => setLegalContent('privacy')} className="hover:text-blue-500">Confidentialité</button>
              </div>
            </div>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;
